import { gql } from "@apollo/client";
import { PROCEDIMIENTO_CONEXION_ID, PROCEDIMIENTO_DESCONEXION_ID } from "../../../../Pages/MisVisitasCreation/constants/procedimientoConexionIds";

const SAVE_VISITA_PROCEDIMIENTO_AP = gql`
    mutation saveVisitaPresencialAPProcedimiento($input: AddVisitaPresencialAPProcedimientoInput!){
        saveVisitaPresencialAPProcedimiento(input: $input) {
            idPresencialAP
            idVisita
        }
    }
`;

export default SAVE_VISITA_PROCEDIMIENTO_AP;

export const adaptAddVisitaPresencialAPProcedimientoInput = (data) => ({
  idPresencialAP: data?.idPresencialAP,
  tensionArterial: data?.tensionArterial,
  temperatura: data?.temperatura,
  frecuenciaCardiaca: data?.frecuenciaCardiaca,
  frecuenciaRespiratoria: data?.frecuenciaRespiratoria,
  procedimientoConexion: !!data.procedimiento?.includes(PROCEDIMIENTO_CONEXION_ID),
  procedimientoDesconexion: !!data.procedimiento?.includes(PROCEDIMIENTO_DESCONEXION_ID),
  curacionCateter: !!data?.curacionCateter,
  cambioBionector: !!data?.cambioBionector,
  controlBomba: !!data?.controlBomba,
  condicionAlmacenamiento: !!data?.condicionAlmacenamiento,
  obsAlmacenamientoNo: data?.obsAlmacenamientoNo,
  stockProductos: !!data?.stockProductos,
  obsStockNo: data?.obsStockNo
});